"use client";

import React from "react";
import { BsFillExclamationCircleFill } from "react-icons/bs";

import Button, { ButtonStyle } from "components/Button";
import Modal from "components/Modal";

const NotificationModal = ({ isOpen, onClose, message }: { isOpen: boolean; onClose: () => void; message: string }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="mb-5 mt-[72px] flex flex-col items-center">
        <div className="item-center mb-[80px] flex items-center justify-center">
          <BsFillExclamationCircleFill className="fill-attention text-[20px]" />
          <p className="ml-2 text-[20px]">{message}</p>
        </div>
        <Button style={ButtonStyle.OUTLINE} onClick={onClose} text="閉じる" width="w-[160px]" />
      </div>
    </Modal>
  );
};

export default NotificationModal;
